<template>
  <div class="SidebarBrand" data-testid="student-sidebar-brand">
    <!-- P39 TR-034 (D-B1-3): the mark goes home. An interaction-only
         deviation -- the prototype's brand is not a link; nothing moves at
         rest, the image's «برنا» alt names the link. -->
    <router-link
      :to="{ name: 'DashboardView' }"
      class="SidebarBrand-home"
      data-testid="student-sidebar-brand-home"
    >
      <img class="SidebarBrand-mark" :src="bornaLogoUrl" alt="برنا" />
    </router-link>
    <span class="SidebarBrand-wordmark">
      <small>{{ $t('appSidebar.brand.tagline') }}</small>
    </span>
  </div>
</template>

<script>
import BornaLogoUrl from '@/assets/logo/borna-identity.png'

export default {
  name: 'sidebar-brand',
  data() {
    return { bornaLogoUrl: BornaLogoUrl }
  },
}
</script>

<style lang="scss" scoped>
// P3 final shell cleanup (00_*.md §13.x, PF-15 defect 2): the rendered
// prototype's own `.sidebar > .brand.brand--compact` block (00_*.md
// design-reference, `.sidebar`), measured via CDP at the 1920x1040 primary
// viewport -- exact pixel values below, not approximated. Replaces the
// legacy user-profile SidebarInfo block for an active student only;
// SidebarInfo itself is untouched and still used for volunteer (AppSidebar/
// index.vue).
.SidebarBrand {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 0 8px 16px;
  border-bottom: 1px solid $borna-border;
  // WP-04V-C: the rendered prototype clears the rule before the first nav row.
  // Without this the nav list started immediately under the border, putting
  // every row 16px high of its measured position.
  margin-bottom: 16px;
}

// P39 TR-034: the link only wraps the mark, so it takes the mark's place in
// the column and the measured geometry stays as it was.
.SidebarBrand-home {
  display: block;
  line-height: 0;
  border-radius: 12px;

  &:focus-visible {
    outline: 2px solid $borna-indigo-300;
    outline-offset: 4px;
  }
}

.SidebarBrand-mark {
  display: block;
  object-fit: contain;
  width: 84px;
  height: 71px;
}

.SidebarBrand-wordmark {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  line-height: 1.35;

  small {
    color: #243ab4;
    white-space: nowrap;
    font-size: 9px;
    font-weight: 800;
  }
}
</style>
